module.exports = __webpack_public_path__ + "static/media/ingredients-green-peas.40ee6f22.png";